module.exports = __webpack_public_path__ + "static/img/200253.37dfe2ae.png";